<template>
  <div class="wish-list-desktop">
    <div v-if="showSkeleton">
      <product-card-skeleton
        v-for="item in 6"
        :key="`wish-list-skeleton-item-${item}`"
        class="wish-list-desktop__item"
      />
    </div>
    <template v-else>
      <product-item
        v-for="item in items"
        :key="item.id"
        :product-id="item.id"
        :basket-item-id="item.id"
        :product-name="item.name"
        :product-code="item.code"
        :amount="item.amount"
        :category-id="getCategoryItem(item)"
        :quantity-available="item.quantity"
        :picture="item.picture"
        :is-deleted="item.isDeleted"
        :is-available="item.isAvailable && item.quantity > 1"
        :is-pre-order="item.isPreOrder"
        :is-buy-only-pre-paid="item.isBuyOnlyPrePaid"
        :is-promo-disabled="item.isPromoDisabled"
        :is-certificate="item.isCertificate"
        :is-gift="item.isGift"
        :author-list="item.author"
        is-authorized
        :is-loading="item.isLoading"
        :is-basket="false"
        :is-loading-add-to-basket="item.isLoadingAddToBasket"
        class="wish-list-desktop__item"
        @spliceWishItem="handlerSpliceWishItem"
        @restoreWishItem="handlerRestoreWishItem"
        @removeWishItem="handlerRemoveWishItem"
        @clickNotAvailable="handlerClickNotAvailable"
        @addToBasketItem="handlerAddToBasketItem"
        @changeTab="handlerChangeTab"
      />
      <div v-if="isMayLoadMore" class="wish-list-desktop__load-more">
        <button-control
          type="more"
          :loading="isLoading"
          :disabled="isLoading"
          @click="handlerLoadMore"
        >
          Показать еще
        </button-control>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { ButtonControl } from '@book24/ui-components';

import ProductItem from '@/components/_desktop/ProductItem/index.vue';
import ProductCardSkeleton from '@/components/ProductCardWishlist/skeleton.vue';

import useWishList from '@/compositions/useWishList';

export default defineComponent({
  name: 'WishList',
  components: {
    ProductItem,
    ProductCardSkeleton,
    ButtonControl,
  },
  props: {
    items: { type: Array, default: () => ([]) },
    isLoading: { type: Boolean, default: false },
    isMayLoadMore: { type: Boolean, default: false },
    showSkeleton: { type: Boolean, default: false },
  },
  setup() {
    const wishList = useWishList();
    return { ...wishList };
  },
});
</script>

<style lang="less">
.wish-list-desktop {
  position: relative;

  &__item {
    border-bottom: 1px solid @gray-super-light;
  }

  &__loader {
    z-index: 2;
  }

  &__load-more {
    margin-top: @size-x5;
  }
}
</style>
